<template>
  <b-card-header class="esep-card-header">
    <h4 class="float-left text-light font-weight-bold">
      <b-icon :icon="this.iconName"></b-icon> {{ title }}
    </h4>
  </b-card-header>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    iconName: {
      type: String,
    },
  },
};
</script>